<app-home [titre]="title" [menu]="menu" version="(4.3)"></app-home>
<p8-spinner></p8-spinner>
<span *ngIf="showLoader" class="loading"></span>
